import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  toggleSupplierFilter,
  toggleSidebarSort,
  selectSupplierStats,
} from '../../redux/slices/selectionSlice';

const SupplierSidebar = () => {
  const dispatch = useDispatch();
  const suppliers = useSelector(selectSupplierStats);
  const { sidebarSort, activeSupplierFilter } = useSelector(s => s.selection);

  const sortIcon = (col) => {
    if (sidebarSort.col !== col) return '↕';
    return sidebarSort.dir === 'asc' ? '↑' : '↓';
  };

  const fmtTotal = (total) =>
    total >= 1000 ? '$' + (total / 1000).toFixed(1) + 'k' : '$' + total.toFixed(0);

  const grandCount = suppliers.reduce((s, r) => s + r.count, 0);
  const grandTotal = suppliers.reduce((s, r) => s + r.total, 0);

  return (
    <div className="sel-supplier-sidebar">
      <div className="sel-sidebar-header">Suppliers</div>
      <table className="sel-sidebar-table">
        <thead>
          <tr>
            <th onClick={() => dispatch(toggleSidebarSort('name'))}>
              Supplier {sortIcon('name')}
            </th>
            <th
              onClick={() => dispatch(toggleSidebarSort('count'))}
              title="Count"
              style={{ textAlign: 'right' }}
            >
              # {sortIcon('count')}
            </th>
            <th
              onClick={() => dispatch(toggleSidebarSort('total'))}
              title="Total Price"
              style={{ textAlign: 'right' }}
            >
              $ {sortIcon('total')}
            </th>
          </tr>
        </thead>
        <tbody>
          {suppliers.map(({ name, count, total }) => (
            <tr
              key={name}
              className={`sel-sidebar-row${activeSupplierFilter === name ? ' active' : ''}`}
              onClick={() => dispatch(toggleSupplierFilter(name))}
              title={name}
            >
              <td className="sel-supplier-name">{name}</td>
              <td style={{ textAlign: 'right' }}>{count}</td>
              <td style={{ textAlign: 'right' }}>{fmtTotal(total)}</td>
            </tr>
          ))}
          <tr className="sel-sidebar-total">
            <td>Total</td>
            <td style={{ textAlign: 'right' }}>{grandCount}</td>
            <td style={{ textAlign: 'right' }}>{fmtTotal(grandTotal)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SupplierSidebar;
